export const style = {
  p: {
    fontSize: `14px`,
    fontWeight: 400
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/style/paragraphs.js